import { render, staticRenderFns } from "./AgeAnalysis.vue?vue&type=template&id=37382d71&scoped=true"
import script from "./AgeAnalysis.vue?vue&type=script&lang=js"
export * from "./AgeAnalysis.vue?vue&type=script&lang=js"
import style0 from "./AgeAnalysis.vue?vue&type=style&index=0&id=37382d71&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37382d71",
  null
  
)

export default component.exports